import { CSpinner } from "@coreui/react";
import P from "components/P";

import { useEffect, useRef, useState } from "react";
export const style = {
  blue: {
    backgroundColor: "#5471E6",
    color: "#ffffff",
    fontWeight: "normal",
    hover: {
      backgroundColor: "#5471E6",
      color: "#ffffff",
    },
  },
  white: {
    backgroundColor: "#ffffff",
    color: "#000000",
    fontWeight: "normal",
    hover: { backgroundColor: "#ffffff", color: "#000000" },
  },
  white_border: {
    backgroundColor: "#ffffff",
    color: "#000000",
    fontWeight: "normal",
    border: "1px solid gray",
    borderRadius: "6px",
    margin: "0px 2px 0px 2px",
    width: "max-content",
    hover: { backgroundColor: "#ffffff", color: "#000000" },
  },
  none: {
    padding: 0,
    borderRadius: null,
    color: null,
    backgroundColor: null,
    fontWeight: null,
    border: 0,
    hover: null,
    selected: null,
    disabled: null,
    hidden: true,
    cursor: "default",
  },
};
function AdminCustomButton(props) {
  const _ = require("lodash");
  const [hover, setHover] = useState(false);
  const input = useRef();
  const isFileButton = props.type === "file";

  let style = _.merge(
    {
      padding: "6px 9px 6px 9px",
      borderRadius: "10px",
      color: "#8a8a8b",
      backgroundColor: "#f0f0f0",
      fontWeight: "bold",
      border: 0,
      hover: { color: "#2276fe" },
      selected: {
        backgroundColor: "#2276fe",
        color: "#ffffff",
      },
      disabled: {
        backgroundColor: "#c0c0c0",
        color: "#808080",
        cursor: "default",
      },
    },
    props.style
  );
  if (style?.disabled && props?.disabled) {
    // disabled가 있으면 항상 먼저 작동
    if (style.disabled?.hover && hover) {
      // hover 작동
      style = _.merge(style, style.disabled, style.disabled.hover);
    } else {
      style = _.merge(style, style.disabled);
    }
  } else if (style?.selected && props?.selected) {
    // selected 있으면 selected 작동
    if (style.selected?.hover && hover) {
      // hover 작동
      style = _.merge(style, style.selected, style.selected.hover);
    } else {
      style = _.merge(style, style.selected);
    }
  } else if (style?.hover && hover) {
    // hover 작동
    style = _.merge(style, style.hover);
  }
  useEffect(() => {}, [props.disabled, props.selected]);

  const content = props.icon ? (
    props.text ? (
      <>
        {props.icon}
        &nbsp;
        {props.text}
      </>
    ) : (
      <>{props.icon}</>
    )
  ) : (
    <>{props.text}</>
  );
  const onChange = () => {
    props.onChange(input.current);
  };
  return (
    <button
      onClick={
        isFileButton
          ? () => input?.current?.click()
          : !props.disabled && props.onClick
      }
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onMouseDown={props.onMouseDown}
      style={_.merge(style, { position: "relative" })}
      ref={props.Ref}
    >
      <P>{content}</P>
      {isFileButton && (
        <input
          ref={input}
          type="file"
          hidden
          onChange={onChange}
          multiple={props.multiple}
          accept={props.accept}
        />
      )}

      {props.isLoading && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <CSpinner />
        </div>
      )}
    </button>
  );
}

export default AdminCustomButton;
